export default {
  components: { },
  props: { },
  data() {
    return { }
  },
  created() {},
  methods: {},
}
